var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusPlan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#383838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5975 29.9679H29.4027C29.7144 29.9679 29.9742 29.7082 29.9742 29.3965V27.9939H10.0261V29.3965C10.0261 29.7601 10.2858 29.9679 10.5975 29.9679ZM30.9092 13.3445C30.0261 13.3445 29.3508 14.0198 29.3508 14.903C29.3508 15.3185 29.5066 15.7341 29.8183 15.9939L25.143 20.7731L20.7274 12.877C21.1949 12.6172 21.5066 12.0978 21.5066 11.5263C21.5066 10.6432 20.8313 9.9679 19.9482 9.9679C19.0651 9.9679 18.3897 10.6432 18.3897 11.5263C18.3897 12.0978 18.7014 12.6172 19.169 12.877L14.7534 20.7731L10.078 15.9939C10.4936 15.7341 10.6495 15.3185 10.6495 14.903C10.6495 14.0198 9.97415 13.3445 9.09103 13.3445C8.20792 13.3445 7.53259 14.0198 7.53259 14.903C7.53259 15.7861 8.20792 16.4614 9.09103 16.4614C9.14298 16.4614 9.19493 16.4614 9.19493 16.4614L10.0261 27.0588H29.9742L30.8053 16.4614C30.8573 16.4614 30.9092 16.4614 30.9092 16.4614C31.7923 16.4614 32.4677 15.7861 32.4677 14.903C32.4677 14.0718 31.7923 13.3445 30.9092 13.3445Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusPlan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus-plan.b1eec4bb8f7547624682c74d642285ed.svg";